/**
 * TanStack Query hooks for `datacenter-ip-database-aws-gcp-azure-do-linode-ovh`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys,
	type CreateDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhBody,
	type ListDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhResponse,
	type DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow,
} from "./api";

export function useDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhList(): UseQueryResult<ListDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhResponse, Error> {
	return useQuery({
		queryKey: datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys.list(),
		queryFn: list,
	});
}

export function useDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhCreate(): UseMutationResult<DatacenterIpDatabaseAwsGcpAzureDoLinodeOvhRow, Error, CreateDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys.all });
		},
	});
}

export function useDatacenterIpDatabaseAwsGcpAzureDoLinodeOvhDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: datacenterIpDatabaseAwsGcpAzureDoLinodeOvhQueryKeys.all });
		},
	});
}
